import React, { useState, createContext, useContext, useEffect } from 'react';

const NavigationContext = createContext({});
const useNavigation = () => useContext(NavigationContext);

function NavigationProvider(props) {
  // console.log('NavigationProvider Load');

  const [navigationData, setNavigationData] = useState({});

  useEffect(() => {
    //컴포넌트가 렌더링 될 때마다 실행되는 hook
    // console.log('NavigationProvider > useEffect()');
  }, []);

  return (
    <NavigationContext.Provider
      value={{ navigationData, setNavigationData }}
      {...props}
    />
  );
}

function withNavigationWatcher(Component) {
  // console.log('withNavigationWatcher Load');

  return function (props) {
    const { path } = props.match;
    const { setNavigationData } = useNavigation();

    useEffect(() => {
      setNavigationData({ currentPath: path });
    }, [path, setNavigationData]);

    return React.createElement(Component, props);
  };
}

export { NavigationProvider, useNavigation, withNavigationWatcher };
